import { Button, Card, Col } from 'antd'
import Meta from 'antd/lib/card/Meta'
import { APP_PREFIX_PATH } from 'configs/AppConfig'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { changeQuantity } from 'redux/actions'
import { isAddonRequired } from 'utils/addons'
import { getAttachment } from 'utils/attachment'
import { addToCart, getQuantity, isItemExistsInCart, subtractItem } from 'utils/cart'

function GridProduct({product, locale}) {

    const [quantity, setQuantity] = useState(0)
    const {cartData: {cartQuantity}, fetchedData: {storeData}} = useSelector(state => state)
    const dispatch = useDispatch()
    
    const addItemToCart=(e, product)=>{
        if (product?.stock && localStorage.getItem('selected-mode')!==null && !isAddonRequired(product?.productAddons)){
            e.preventDefault();
            if ( product?.stock>quantity){
                addToCart({...product, chosenAddons:product?.productAddons});
                dispatch(changeQuantity(1))
            }
        }
    }
    const subtractItemFromCart=(e, product)=>{
        e.preventDefault();
        subtractItem(product)
        dispatch(changeQuantity(-1))
    }

    useEffect(() => {
        setQuantity(getQuantity(product.id, product?.productAddons))
    }, [cartQuantity])

  return (
    <>
        <Col xs={12} sm={8} md={6} lg={12} key={product.id}>
            <div className=" grid-product-image-container">
                <Link to={APP_PREFIX_PATH+'/products/'+product.id}>
                    <Card
                        bordered={false}
                        cover={<img 
                            className={`grid-product-image position-relative ${!product?.stock && 'soldOut'}`} 
                            alt="example" 
                            src={product?.images?.length ? 
                                getAttachment(product?.images[0].id) : 
                            '/img/productsFallback.svg'}
                        />}
                    >
                        {!product?.stock && <div className='soldOutText'>Sold out</div>}
                        {product?.label && <div className={'grid-label'} style={{color: product?.label?.colorLight, backgroundColor: product?.label?.colorDark}}>
                            {locale === 'en' ? product?.label?.titleEng : product?.label?.titleAr}
                        </div>}
                        <Meta
                            className={`${!product?.stock && 'soldOut'}`}
                            title={<span className='text-black'>{locale==='en' ? product?.nameEng.toUpperCase() : product?.nameAr.toUpperCase()}</span>}
                            description={
                                (isItemExistsInCart(product?.id, product?.productAddons) && !isAddonRequired(product?.productAddons)) ? <div className='counterContainer d-flex justify-content-center align-items-center'>
                                    <img onClick={(e)=>subtractItemFromCart(e, product)} src='/img/minusItem.svg' alt='minus' className='changeQuantity'/>
                                    <div className='mx-3 text-black font-16'>{quantity}</div>
                                    <img onClick={(e)=>addItemToCart(e, product)} src='/img/plusItem.svg' alt='plus' className={`changeQuantity ${quantity===product?.stock && 'disabledSoldOutCounter'}`}/>
                                </div> :
                                <Button onClick={(e)=>addItemToCart(e, product)} className='card-button text-black w-100 px-2 priceOnSelectBtn'>
                                    {
                                        isAddonRequired(product?.productAddons) ? 'Price on selection' : <div className='d-flex align-items-center justify-content-between'>
                                            <span> {storeData?.currency?.name ? storeData?.currency.name : "KWD" } {product?.price}</span>
                                            <img src='/img/addToCart.svg' alt='addToCart'/>
                                        </div>
                                    }
                                </Button>
                            }
                        />
                    </Card>
                </Link>
            </div>
        </Col>
    </>
  )
}

export default GridProduct